import { useState, useEffect, useRef } from "react";
import { Input, Image, Select, message } from "antd";
import IngredientInput from "./IngredientInput";
import { INVENTORY_ADUSTMENT_TYPE_UNIT } from "../../../constant/constants";
import {
  calculateSellingPrice,
  getExistingProfits,
  getTotalIngredientCost,
} from "../../../services/inventory/recipe.service";
import IngredientInputSkeleton from "./IngredientInputSkeleton";
import CustomInputNumber from "../../CustomInputNumber";
import { getParsedNumber, roundNumber } from "../../../utils/Common";
import CustomInputNumberNg from "../../CustomInputNumberNg";

let isProfitManualEdited = false;

export default function RecipeVariantContainer({
  isCategorySelected,
  allIngredients,
  ingredientDropdownData,
  currentRecipeVariant,
  recipeReadyFoodType,
  onAddIngredient = () => {},
  onRemoveIngredient = () => {},
  updateRecipeVariantField = () => {},
}) {
  const profitRef = useRef("");
  const {
    ingredients,
    ingredientCost,
    operationalCost,
    totalCost,
    profitAmount,
    profitPercent,
    isProfitInPercent,
    sellingPrice,
    tempVarId,
  } = currentRecipeVariant;

  const [ingredientCostPerDish, setIngredientCostPerDish] = useState(0);
  const [ingredientOperationalCost, setIngredientOperationalCost] = useState(0);
  const [ingredientProfitAmount, setIngredientProfitAmount] = useState(0);
  const [profitType, setProfitType] = useState(
    isProfitInPercent === "Yes" ? INVENTORY_ADUSTMENT_TYPE_UNIT[1].value : INVENTORY_ADUSTMENT_TYPE_UNIT[0].value
  );
  const [ingredientTotalCost, setIngedientTotalCost] = useState("");
  const [ingredientSellingPrice, setIngredientSellingPrice] = useState("");
  const [isVariantProfitInPercent, setIsVariantProfitInPercent] = useState("No");

  /*** init component */
  useEffect(() => {
    setIngredientCostPerDish(ingredientCost || "");
    setIngredientOperationalCost(operationalCost);
    setIngedientTotalCost(totalCost || "");

    setIsVariantProfitInPercent(isProfitInPercent);

    setIngredientSellingPrice(sellingPrice || "");
    console.log('=========recipeReadyFoodType=======', {recipeReadyFoodType});
    if (recipeReadyFoodType === 'INGREDIENT') {
      onChangeSellingPrice(totalCost || 0)
    }
  }, [ingredientCost, operationalCost, totalCost, profitAmount, sellingPrice, isProfitInPercent, profitType, recipeReadyFoodType]);

  function onHandleIngredientOperationalCost(val) {
    const operationalCost = val;

    updateRecipeVariantField("variants", tempVarId, "operationalCost", operationalCost);
    setIngredientOperationalCost(operationalCost);
  }

  function onChangeSellingPrice(val) {
    setIngredientSellingPrice(val);
    updateRecipeVariantField("variants", tempVarId, "sellingPrice", val);
  }

  function onHandleProfitType(val) {
    // TK
    let tempIsProfitPercent = "";
    if (val === INVENTORY_ADUSTMENT_TYPE_UNIT[0].value) {
      tempIsProfitPercent = "No";
    } else {
      tempIsProfitPercent = "Yes";
    }
    setIsVariantProfitInPercent(tempIsProfitPercent);
    updateRecipeVariantField("variants", tempVarId, "isProfitInPercent", tempIsProfitPercent);
    setProfitType(val);
  }

  // calculate the ingredientCostPerDish
  useEffect(() => {
    const ingredientTotalCost = getTotalIngredientCost(ingredients);
    updateRecipeVariantField("variants", tempVarId, "ingredientCost", ingredientTotalCost);
    setIngredientCostPerDish(ingredientTotalCost);
  }, [ingredients, tempVarId]);

  // calculate the totalCost
  useEffect(() => {
    const totalCost = roundNumber(getParsedNumber(ingredientCostPerDish) + getParsedNumber(ingredientOperationalCost));
    updateRecipeVariantField("variants", tempVarId, "totalCost", totalCost);
    setIngedientTotalCost(totalCost);
  }, [ingredientCostPerDish, ingredientOperationalCost, tempVarId]);

  // M modified
  useEffect(() => {
    if (isProfitManualEdited) {
      isProfitManualEdited = false;
      return;
    }

    let profit = 0;

    if (profitType === "PERCENT") {
      profit = roundNumber(
        ((getParsedNumber(sellingPrice) - getParsedNumber(totalCost)) / getParsedNumber(totalCost)) * 100
      );
    } else {
      profit = roundNumber(getParsedNumber(sellingPrice) - getParsedNumber(totalCost));
    }

    profit = Number.isFinite(profit) ? profit : "N/A";
    setIngredientProfitAmount(profit);
    updateRecipeVariantField("variants", tempVarId, "profitAmount", profit);

    const tmpTxt = getExistingProfits(currentRecipeVariant, totalCost, sellingPrice, profitType, profitRef);
    profitRef.current = tmpTxt;
  }, [totalCost, profitType, tempVarId, sellingPrice]);
  //end M

  return (
    <div className="min-h-[424px] bg-[#FFFEEC] border border-px border-[#E2E2E2] drop-shadow-lg pt-[33px] pl-[42px] pr-[59px] pb-[56px]">
      <div className="flex items-start mb-[50px]">
        {/* recipe ingredients */}
        <div className="w-full h-auto">
          {/* item header */}
          <div className="flex items-center space-x-3 font-p_medium text-xs leading-[13px] text-black mb-[10px] mr-[37.67px]">
            <p className="w-[204px]">
              Ingredient<span className="text-red-500 pl-1">*</span>
            </p>
            <p className="w-[80px]">
              Quantity<span className="text-red-500 pl-1">*</span>
            </p>
            <p className="w-[123px]">Unit</p>
            <p className="w-[108px]">Cost</p>
          </div>
          {Boolean(ingredients) && ingredients.length > 0 ? (
            ingredients.map((ingredient, idx) => (
              <div className="w-full flex items-center gap-x-[15px] mb-3" key={`ingredient-${idx}`}>
                <IngredientInput
                  isCategorySelected={isCategorySelected}
                  updateRecipeVariantField={updateRecipeVariantField}
                  tempVariantId={tempVarId}
                  allIngredients={allIngredients}
                  currentIngredient={ingredient}
                  ingredientDropdownData={ingredientDropdownData}
                />

                {idx === ingredients.length - 1 ? (
                  <div className="flex items-center space-x-2">
                    {idx > 0 && (
                      <button
                        className=""
                        onClick={() => {
                          onRemoveIngredient(tempVarId, ingredient.tempIngredientId);
                        }}
                      >
                        <Image src="/images/icons/remove_one.svg" preview={false} />
                      </button>
                    )}
                    <button className="" onClick={() => onAddIngredient(tempVarId)}>
                      <Image src="/images/icons/add_one.svg" preview={false} />
                    </button>
                  </div>
                ) : (
                  <button
                    className=""
                    onClick={() => {
                      onRemoveIngredient(tempVarId, ingredient.tempIngredientId);
                    }}
                  >
                    <Image src="/images/icons/remove_one.svg" preview={false} />
                  </button>
                )}
              </div>
            ))
          ) : (
            <IngredientInputSkeleton />
          )}
        </div>

        {/* cost / operations cost / total cost */}
        <div className="">
          <div className="h-[32px] w-[139px] mb-[35px]">
            <label className="font-p_medium text-black leading-[13px] text-xs pb-[7px]">Cost/Dish (TK)</label>
            <Input
              disabled
              name="costPerDish"
              className={"w-full h-full"}
              value={Number(ingredientCostPerDish)?.toFixed(2)}
            />
          </div>
          <div className="h-[32px] w-[139px] mb-[35px]">
            <label className="font-p_medium text-black leading-[13px] text-xs pb-[7px]">Operational Cost (TK)</label>
            <CustomInputNumber
              value={ingredientOperationalCost}
              setValue={onHandleIngredientOperationalCost}
              min={0}
              max={99999}
              isDecimalAllowed={true}
              disabled={!isCategorySelected}
            />
          </div>
          <div className="font-p_medium text-black leading-[13px] text-base pb-[7px] text-right w-[139px] mt-[50px]">
            <h1 className="mb-2">Total Cost</h1>
            <p>{Number(ingredientTotalCost)?.toFixed(2)} TK</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-end space-x-[78px]">
        <div>
          <label className="font-p_medium text-black leading-[13px] text-xs pb-[7px]">
            <span className="text-red-500 pr-[0.5px]">*</span>Profit{" "}
            {/* <span className="text-[11px] text-gray-600">{profitRef.current}</span> */}
          </label>
          <div className="flex items-center space-x-[5px]">
            <div className="h-[32px] w-[80px]">
              <CustomInputNumberNg
                value={ingredientProfitAmount}
                setValue={() => {}}
                isDecimalAllowed={true}
                min={-99999}
                disabled={true}
                inputClasses={`${getParsedNumber(ingredientProfitAmount) < 0 ? "text-red-600" : "text-black"}`}
              />
            </div>
            <div className="w-[60px] h-[32px]">
              <Select
                disabled={!isCategorySelected}
                value={profitType}
                name="profitType"
                style={{ width: "100%", height: "100%" }}
                onChange={onHandleProfitType}
                options={INVENTORY_ADUSTMENT_TYPE_UNIT}
              />
            </div>
          </div>
        </div>

        <div className="h-[32px] w-[200px] mb-[35px]">
          <label className="font-p_medium text-black leading-[13px] text-xs pb-[7px]">
            <span className="text-red-500 pr-[0.5px]">*</span>Selling Price (TK)
          </label>
          {/* <Input
            type="number"
            disabled
            name="sellingPrice"
            className={"w-full h-full"}
            value={Number(ingredientSellingPrice)?.toFixed(2)}
          /> */}
          <CustomInputNumber
            name="sellingPrice"
            value={ingredientSellingPrice}
            setValue={onChangeSellingPrice}
            isDecimalAllowed={true}
            disabled={recipeReadyFoodType === 'INGREDIENT'}
          />
        </div>
      </div>
    </div>
  );
}
